import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "current" }
const _hoisted_3 = {
  class: "select",
  ref: "select"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "time-separator" }, ":", -1)
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control-time", { open: _ctx.isOpen }]),
    tabindex: "0",
    onBlur: _cache[2] || (_cache[2] = () => (_ctx.isOpen = false)),
    onFocus: _cache[3] || (_cache[3] = () => (_ctx.isOpen = true))
  }, [
    (!!_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label) + ":", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text) + _toDisplayString(_ctx.currentTime.displayTime), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "hours",
        onWheel: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScrollHours && _ctx.onScrollHours(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTime.hoursElements, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["select-item", { active: item.value === _ctx.currentTime.Hours }]),
            key: index,
            style: _normalizeStyle(_ctx.getHourItemStyle(item)),
            onClick: ($event: any) => (_ctx.setHour(item))
          }, _toDisplayString(_ctx.currentTime.displayTimeItem(item.value)), 15, _hoisted_4))
        }), 128))
      ], 32),
      _hoisted_5,
      _createElementVNode("div", {
        class: "minutes",
        onWheel: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScrollMinutes && _ctx.onScrollMinutes(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTime.minutesElements, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["select-item", { active: item.value === _ctx.currentTime.Minutes }]),
            key: index,
            style: _normalizeStyle(_ctx.getMinuteItemStyle(item)),
            onClick: ($event: any) => (_ctx.setMinute(item))
          }, _toDisplayString(_ctx.currentTime.displayTimeItem(item.value)), 15, _hoisted_6))
        }), 128))
      ], 32)
    ], 512)
  ], 34))
}